<script lang="ts">
    import BaseTransitionSingleNode from "../BaseTransitionSingleNode.svelte";
    import { select_transition, transition_delete } from "../actions/transition";
    import type { MachineStateMealy } from "../state/machineState";
    import type { TransitionMealy } from "../state/transition";
    import { EditMode } from "../state/uiState";
    import TextBlockWithAnchor from "../text/TextBlockWithAnchor.svelte";

    export let transition: TransitionMealy;
    export let machineState: MachineStateMealy;

    import { getUpdateMachineState } from './context';
    import type { MealyMachineError } from "./mealyErrorsInMachine";
    import { calcHighlightLineNr, calcIsHighlighted } from "./mealyTransitionFunctions";
    const updateMachineState = getUpdateMachineState();
    
    $: uiState = machineState.uiState;

    $: isLastUsedTransition = machineState.executionState?.lastTransition?.id === transition.id;

    // $: color = (() => {
    //     if (uiState.editMode === EditMode.EXECUTION) {
    //         if (machineState.executionState?.lastTransition?.id === transition.id) {
    //             return 'coral';
    //         } else {
    //             return 'black';
    //         }
    //     } else {
    //         if (uiState.selection.transitionId === transition.id) {
    //             return 'coral';
    //         } else {
    //             return 'black';
    //         }
    //     }
    // })();

    $: isHighlighted = calcIsHighlighted(machineState, transition.id);
    // $: isHighlighted = (() => {
    //     if (uiState.editMode === EditMode.EXECUTION) {
    //         return machineState.executionState?.lastTransition?.id === transition.id
    //     } else {
    //         return uiState.selection.transitionId === transition.id
    //     }
    // })();

    $: color = isHighlighted ? 'coral' : 'black';
    $: strokeWidth = isHighlighted ? '3' : '1';
    $: marker = isHighlighted ? 'url(#markerArrowHighlighted)' : 'url(#markerArrow)';

    function handleClick() {
        console.log('handleClick()');
        if (uiState.editMode === EditMode.NEUTRAL) {
            const newMachineState = select_transition(machineState, transition.id);
            updateMachineState(newMachineState);
        } else if (uiState.editMode === EditMode.DELETE) {
            console.log('delete transition')
            const newMachineState = transition_delete(machineState, transition.id);
            updateMachineState(newMachineState);
        }
    }

    function errorIncludesTransition(machineErrors: Array<MealyMachineError>, transitionId: string) {
        return machineErrors.some(error => error.transitionId1 === transitionId);
    }

    $: highlightLineNr = calcHighlightLineNr(machineState, transition.id);
    // $: highlightLineNr = (() => {
    //     if (machineState.uiState.editMode !== EditMode.EXECUTION) {
    //         return -1;            
    //     }

    //     const isLastUsedTransition = machineState.executionState?.lastTransition?.id === transition.id;

    //     if (isLastUsedTransition) {
    //         return machineState.executionState.lastCharIndex;
    //     } else {
    //         return -1;
    //     }
    // })()
</script>

<BaseTransitionSingleNode
    transition={transition}
    machineState={machineState}
    color={color}
    strokeWidth={strokeWidth}
    marker={marker}
    updateMachineState={updateMachineState}
    onClick={handleClick}
    error={errorIncludesTransition(machineState.errors, transition.id)}
    let:anchorPosition={anchorPosition}
>
    <!-- TODO: Positionierung des Textes verbessern (vgl. z.B. flaci)
    <text
        text-anchor="middle"
        pointer-events="none"
    >
        {#each transition.singleTransitions as char}
            {@const color = isLastUsedTransition && machineState.executionState?.lastChar === char.char ? 'coral' : 'black'}
            <tspan x="0" dy="1.2em" fill={color}>{char.char}|{char.output}</tspan>
        {/each}
    </text> -->
    <TextBlockWithAnchor
        text={transition.singleTransitions.map(char => `${char.char}|${char.output}`)}
        highlightLineNr={highlightLineNr}
        anchorPosition={anchorPosition}
    />
</BaseTransitionSingleNode>